<template>
    <b-container class="custom-height" :fluid="$router.currentRoute.name === 'kiosk'">
        <router-view></router-view>
        <order-preview-modal></order-preview-modal>
    </b-container>
</template>

<script>
import OrderPreviewModal from "@/components/orders/OrderPreviewModal";

export default {
    name:       'CoreView',
    components: {OrderPreviewModal},
    mounted() {
        if (!navigator.onLine) {
            this.$router.push({name: 'offline'});
        }

        window.addEventListener('offline', this.handleOffline);

        window.addEventListener('online', this.handleOnline);
    },
    beforeDestroy() {
        window.removeEventListener('offline', this.handleOffline);
        window.removeEventListener('online', this.handleOnline);
    },
    methods: {
        handleOffline() {
            this.$router.push({name: 'offline'});
        },
        handleOnline() {
            this.$router.push({name: 'menu-items'});
        }
    }
}
</script>

<style>
.custom-height {
    height: calc(100% - 66px);
}
</style>